export default __webpack_public_path__ + "ba4a431697579bdfef48455abdab3353.svg";